<template>
  <div class="slider-container">
    <div class="container-fluid">
      <swiper ref="mySwiper" :options="swiperOptions">
        <!-- <swiper-slide :data-swiper-autoplay="duration + '000'">
            <div class="slide-header" :style="{backgroundImage: `url(${require('../../assets/iahs/slider.png')})`}">
                <div class="widget">
                    <div class="top-line" :style="{backgroundColor: `${'#B99B47'}`}"></div>
                    <div class="bg-title mb-3 text-uppercase" v-html="'International Academy<br /> for Homeland Security '"></div>
                    <router-link to="/" class="ih-btn">
                      <div class="d-flex align-items-center">
                        <span v-html="'Explore'"></span>
                        <span class="icon-arrow-right ml-2 icon"></span>
                      </div>
                    </router-link>
                </div>
            </div>
        </swiper-slide> -->
        <swiper-slide v-for="(row, index) in rows" :key="index" :data-swiper-autoplay="row.duration + '000'">
            <div class="slide-header" :style="{backgroundImage: `url(${row.file})`}">
                <div class="widget">
                    <div class="top-line" :style="{backgroundColor: `${row.lineColor1} !important`}"></div>
                    <div class="bg-title mb-3 text-uppercase" v-html="row.title"></div>
                    <router-link :to="row.redirect" class="ih-btn">
                      <div class="d-flex align-items-center">
                        <span v-html="row.button"></span>
                        <span class="icon-arrow-right ml-2 icon"></span>
                      </div>
                    </router-link>
                </div>
            </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="swiper-pagination" slot="pagination"></div>
  </div>
</template>

<style scoped>
.slider-container {
  background: #0D0D34;
}
.swiper-container {
  /* height: calc(100vh - 99.91px); */
  height: 600px;
  min-height: 500px;
  /* min-height: 600px; */
  position: relative;
  border-bottom: 4px solid #C0A04A;
}
.slide-header {
    height: 100%;
    background-size: cover;
    border-bottom: 7px solid #0D0D34;
}
.widget {
    position: absolute;
    left: 60px;
    bottom: 70px;
}
.bg-title {
    color: #fff;
    font-size: 40px;
}
.top-line {
    height: 6px;
    width: 100px;
    margin-bottom: 20px;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .swiper-container {
    height: 508px;
    /* min-height: auto; */
  }
  .slide-header {
    padding: 0;
    background-position: center;
  }
  .widget {
    left: 0;
    bottom: 40px;
    padding: 20px;
  }
  .bg-title {
    font-size: 36px;
    margin-bottom: 24px;
  }
  .explore-btn {
    writing-mode: inherit;
    text-orientation: initial;
    position: static;
    transform: none;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .bg-title {
    font-size: 56px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .swiper-container {
    height: calc(100vh - 91.45px);
    /* min-height: auto; */
  }
  .slide-header {
    padding: 100px 20px 95px;
  }
  /* .widget {
    position: static;
  } */
  /* .bg-title {
    font-size: 40px;
    margin-bottom: 24px;
  } */
  .explore-btn {
    writing-mode: inherit;
    text-orientation: initial;
    /* position: static; */
    /* transform: none; */
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
// Very Important npm install swiper@5.4.5 
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Slider",
//   props: ['row'],
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  
  data() {
    return {
      pgLoading: true,
      duration: 4,
      rows: [],
      swiperOptions: {
        loop: false,
        speed: 800,
        autoplay: {
            
          // delay: 4000, or data-swiper-autoplay="2000" in html
        },
        spaceBetween: 10,
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
      }
    };
  },
  created() {
    this.fetchSlider();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
        })
        .catch(() => {});
    },
    prev() {
        this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
        this.$refs.mySwiper.$swiper.slideNext();
    },
  },
};
</script>
